
import { i18nText } from '@/locales';

import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from 'vue-class-component';
import { ProxyDataForm } from '@/UI/components/Helpers/ProxyDataForm';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { Component } from 'vue-property-decorator';
import { Button, Menu, List, Row, Table } from 'ant-design-vue';
import { DocumentsStore } from '@/store/modules/Documents';

@Component({
    components: {
        PageTitle,
        BaseDataForm,
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-table': Table,
        'a-row': Row,
    },
})
export default class FinanceDocuments extends mixins(ProxyDataForm) {

    data: any = []

    downloadDocumnet(record: any) {
        console.warn(record)
        let fileURL = window.URL.createObjectURL(new Blob([record.file]))
        let fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', record.file.name)
        document.body.appendChild(fileLink)

        fileLink.click()
    }
    async deleteDocument(record: any) {
        console.warn(record)
        await DocumentsStore.delete(record.id)
        await this.getData()
    }

    async getData() {
        await DocumentsStore.fetchAll({filter: {client_id: this.$route.params['id']}})
        this.data = DocumentsStore.items?.data
    }

    async AddDocumnent(file: any) {
        console.clear()
        console.error(file.file)
        const fd = new FormData()
        fd.append('client_id', this.$route.params['id'])
        fd.append('file', new Blob(file.fileList), file.fileList[0].name)
        await DocumentsStore.save(fd)
    }
    async created(): Promise<void> {
        try {
            await this.getData()
            this.formReady = true;
            this.tableLoad = true;
        } catch (e) {
            console.log('Clients documents form Error');
        }
    }

    get columns() {
        return [
            {
                title: i18nText("Название"),
                dataIndex: 'file.name',
                key: 'name',
            },
            {
                title: i18nText("Размер"),
                dataIndex: 'size',
                key: 'size',
            },
            {
                title: i18nText("Дата"),
                dataIndex: 'created_at',
                key: 'created_at',
            },
            {
                title: i18nText("Действия"),
                dataIndex: 'delordow',
                key: 'delordow',
                scopedSlots: {
                    customRender: 'action'
                }
            },
        ]
    }
}
